import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { publicRequest } from "utils";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { useMeta } from "hooks";

export interface useBlogModalContentArgs {
  id: number;
}

export const useBlogModalContent = ({ id }: useBlogModalContentArgs) => {
  const { setMetaTags } = useMeta();
  const navigate = useNavigate();
  const { language } = useSelector((state: RootState) => state.global);

  const { data: blogContent } = useQuery(
    [language, id, "blog-content"],
    () =>
      publicRequest({
        url: `/api/blog/${id}/${language}`,
        method: "get"
      }),
    {
      onSuccess: (res) => {
        setMetaTags(res?.data?.meta);
      },
      onError: () => {
        navigate("/blog");
        document.body.classList.remove("fixed_body");
      }
    }
  );

  return {
    blogContent: blogContent?.data
  };
};
